import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { formatApiError } from '@/lib/api';
import { AUTH } from '@/constants/testIds';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      await login(email, password);
      toast.success('Accesso effettuato');
      nav('/dashboard');
    } catch (e) {
      const msg = formatApiError(e);
      setErr(msg); toast.error(msg);
    } finally { setBusy(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] max-w-7xl mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-2 gap-16 items-center">
      <div className="hidden lg:block">
        <div className="text-xs uppercase tracking-[0.25em] font-bold text-terracotta mb-6">Accedi</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter leading-none">Bentornato.</h1>
        <p className="mt-6 text-muted-foreground max-w-md">Riprendi da dove hai lasciato: preferiti, ricerche salvate e conversazioni ti aspettano.</p>
      </div>
      <form onSubmit={submit} data-testid={AUTH.loginForm} className="rounded-2xl border border-border p-8 md:p-10 bg-card space-y-5 max-w-md w-full">
        <h2 className="font-display text-2xl">Accedi ad AgriNexus</h2>
        <div className="space-y-2">
          <Label>Email</Label>
          <Input type="email" data-testid={AUTH.loginEmail} value={email} onChange={e=>setEmail(e.target.value)} required autoFocus/>
        </div>
        <div className="space-y-2">
          <Label>Password</Label>
          <Input type="password" data-testid={AUTH.loginPassword} value={password} onChange={e=>setPassword(e.target.value)} required/>
          <div className="text-right">
            <Link to="/password/dimenticata" data-testid="forgot-password-link" className="text-xs text-muted-foreground hover:text-foreground link-underline">
              Password dimenticata?
            </Link>
          </div>
        </div>
        {err && <div className="text-sm text-destructive">{err}</div>}
        <Button type="submit" disabled={busy} data-testid={AUTH.loginSubmit} className="w-full rounded-full h-11">
          {busy ? 'Accesso in corso…' : 'Accedi'}
        </Button>
        <div className="relative py-2">
          <div className="absolute inset-0 flex items-center"><span className="w-full border-t border-border"/></div>
          <div className="relative flex justify-center text-xs uppercase tracking-widest"><span className="bg-card px-3 text-muted-foreground">oppure</span></div>
        </div>
        <Button type="button" variant="outline" onClick={googleLogin} data-testid={AUTH.loginGoogle} className="w-full rounded-full h-11">
          Continua con Google
        </Button>
        <div className="text-sm text-center text-muted-foreground">
          Non hai un account? <Link to="/registrati" className="font-medium text-foreground link-underline">Registrati</Link>
        </div>
      </form>
    </div>
  );
}
